import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '為替カレンダー',
    titleCn: '汇率',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  titleCn: strings.titleCn,
  listed: true,
  staffOnly: true,
  order: 2,
};
